export default __webpack_public_path__ + "images/9d06a249257c9861dd260f50f0121de2.png";